import { render, staticRenderFns } from "./SelectSpe.vue?vue&type=template&id=061ae2c0&scoped=true&"
import script from "./SelectSpe.vue?vue&type=script&lang=js&"
export * from "./SelectSpe.vue?vue&type=script&lang=js&"
import style0 from "./SelectSpe.vue?vue&type=style&index=0&id=061ae2c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ae2c0",
  null
  
)

export default component.exports